import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import { Navbar, Footer } from './components/Layout';
import AnnouncementBanner from './components/AnnouncementBanner';
import AppRoutes from './routes/AppRoutes';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <AnnouncementBanner />
          <Navbar />
          <AppRoutes />
          <Footer />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
